module.exports = __webpack_public_path__ + "static/media/emma_zoom.18bb8287.png";